import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2 bg-yellow text-black font-bold text-center" }
const _hoisted_2 = { class: "flex min-h-screen" }
const _hoisted_3 = { class: "py-2 px-8 mobile:w-6/6 tablet:w-6/6 desktop:w-full bg-gray-light" }
const _hoisted_4 = { class: "py-4 h-16 border-b border-gray" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-16" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarMenuAkahon = _resolveComponent("SidebarMenuAkahon")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshApp && _ctx.refreshApp(...args)))
      }, " An update is available.. Update now by clicking this banner :) ")
    ], 512), [
      [_vShow, $setup.user.updateExists]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SidebarMenuAkahon),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppHeader)
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_router_view)
        ], 512), [
          [_vShow, $setup.user.isAuthenticated]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('i18n.login.header')), 1),
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('i18n.username')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.email) = $event)),
            type: "text",
            class: "p-2 m-2 rounded"
          }, null, 512), [
            [_vModelText, $data.email]
          ]),
          _hoisted_5,
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('i18n.password')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.password) = $event)),
            type: "password",
            class: "p-2 m-2 rounded",
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => ($setup.user.userLogin($data.email,$data.password)), ["enter"]))
          }, null, 544), [
            [_vModelText, $data.password]
          ]),
          _hoisted_6,
          _createElementVNode("button", {
            class: "appButton",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.user.userLogin($data.email,$data.password)))
          }, _toDisplayString(_ctx.$t('i18n.login.login')), 1),
          _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.$t('i18n.login.error')), 513), [
            [_vShow, $setup.user.errors.length != 0]
          ])
        ], 512), [
          [_vShow, !$setup.user.isAuthenticated]
        ]),
        _hoisted_7
      ])
    ])
  ], 64))
}